import { useTranslate } from '@tolgee/react'
import { TomAutoComplete, TomAutoCompleteProps } from '@tom-ui/ui'
import { CarrierVisitStatus } from '@yard/app/api'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

type Props<M extends boolean = false> = {
  onChange: (carrierType: M extends true ? CarrierVisitStatus[] : CarrierVisitStatus) => void
} & TomAutoCompleteProps<CarrierVisitStatus, M>

export const CarrierVisitStatusAutoComplete = observer(
  <M extends boolean = false>(props: Props<M>) => {
    const { t } = useTranslate()
    const { dataCy, defaultValue, label, onChange } = props

    const [options] = useState<CarrierVisitStatus[]>(() => Object.values(CarrierVisitStatus))

    return (
      <TomAutoComplete
        {...props}
        dataCy={dataCy ?? 'carrier-visit-status-autocomplete'}
        label={label ?? t('carrierVisitStatus', 'Carrier Visit Status')}
        options={options}
        defaultValue={defaultValue}
        enablePortal
        placeholder={t('visitStatus', 'Visit status')}
        onChangeEntity={entity => {
          onChange(entity as M extends true ? CarrierVisitStatus[] : CarrierVisitStatus)
        }}
      />
    )
  },
)
